import Vue from 'vue';
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toData, to } from './promiseHandle';
import { OptionItem } from '@/models/Coupon';
import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';

export class AdditionalOptionsService {
    private baseAPI = process.env.VUE_APP_API_URL;
    private commonAPI = process.env.VUE_APP_API_COMMON_URL;
    private authService = new AuthenService();
    private commonService = new CommonService();

    constructor() {
    }

    get headers() {
        return {
            'Content-Type': 'application/json',
            'auth': localStorage.getItem('token'),
        };
    }

    public async getKyotens() {
        return this.commonService.getKyotens();
    }

    public async getAdditionalOptions(form: any, id?: number) {
        const q = `kyotenCd=${form.kyotenCd},groupCd=${form.groupCd},shatenCd=${form.shatenCd}`;
        const path = id ?
        `${this.baseAPI}/additional-options/${id}` : `${this.baseAPI}/additional-options?q=${q}`;
        const { result, error } = await this.commonService.get(path);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getAdditionalOptions');
            return;
        }
    }

    public async editAdditionalOptions(data: OptionItem) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/additional-options/`, {
            ...data
        });
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'editAdditionalOptions');
            return;
        }
    }

    public async deleteAdditionalOptions(id: number) {
        const { result, error } = await this.commonService.delete(`${this.baseAPI}/additional-options/${id}`);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'deleteAdditionalOptions');
            return;
        }
    }

    public async saveAdditionalOptions(data: any[], base: any) {
        const q = `groupCd=${base.groupCd},shatenCd=${base.shatenCd},kyotenCd=${base.kyotenCd}`;
        const url = `${this.baseAPI}/additional-options-order-display?q=${q}`;
        const { result, error } = await this.commonService.put(url, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'handleError');
            return;
        }
    }

    public async cloneData(data: any[]) {
        const { result, error } = await this.commonService.post(`${this.baseAPI}/additional-options-clone`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'handleError');
            return;
        }
    }

    public async getShowFlag(form: any) {
        let path = `${this.baseAPI}/displayoption?q=kyotenCd=${form.kyotenCd}`;
        path += `,groupCd=${form.groupCd},shatenCd=${form.shatenCd}`;
        const { result, error } = await this.commonService.get(path);
        if (result) {
            return result.data;
        } else {
            this.authService.handleError(error, 'getShowFlag');
            return;
        }
    }

    public async saveShowAdditionalOptions(data: any) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/displayoption`, data);
        if (result) {
            return result.status;
        } else {
            this.authService.handleError(error, 'handleError');
            return;
        }
    }

    // ============================





}
